import MatchAssetsModal from './MatchAssetsModal';

export type { MatchAssetsModalProps } from './MatchAssetsModal';
export default MatchAssetsModal;
